const GoogleAnalyticsObject = 'dnga';
const DEFINES = [

  /**
   * 旧GA
   * @todo
   *   2019/3の年度更新時に削除する
   * @see
   *   https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2019-25
   */
  {
    name: 'dnold',
    id: 'UA-103561119-1',
    pageview: false,
    rule: function(gaManager) {
      return gaManager.context.$store.getters['config/isBene'];
    },
  },

  /**
   * 最新GA
   * DN2019の本番用資材公開時からの利用
   * @see
   *   https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2019-25
   */
  {
    name: 'dn',
    id: 'UA-127678425-1',
    pageview: true,
    rule: function(gaManager) {
      return gaManager.context.$store.getters['config/isBene'];
    },
  },

  /**
   * 開発時用のGAID
   * 環境設定でドメインがbenesseのものでなかった場合に採用される
   * UA-1614455-19
   */
  {
    name: 'dev',
    pageview: true,
    cookieDomain: 'none',
    get id() {
      return decaesar('VB.2725566.2:', 1);
    },
    rule: function(gaManager) {
      return !gaManager.context.$store.getters['config/isBene'];
    },
  },

  // 複数GAのテスト用
  {
    name: 'dev2',
    pageview: true,
    cookieDomain: 'none',
    get id() {
      return decaesar('VB.2725566.2:', 1);
    },
    rule: function(gaManager) {
      return !gaManager.context.$store.getters['config/isBene'];
    },
  },
];

// // シーザーー暗号化
// function caesar(val, key) {
//   let = encodeURIComponent(val);
//   let result = '';
//   for (let i = 0; i < val.length; i++) {
//     result += String.fromCharCode(val.charCodeAt(i) + key);
//   }
//   return result;
// }

// シーザー復号化
function decaesar(val, key) {
  let result = '';
  for (let i = 0; i < val.length; i++) {
    result += String.fromCharCode(val.charCodeAt(i) - key);
  }
  return decodeURIComponent(result);
}


export default class GaManager {

  // getters
  get isEmpty() { return this.uses.length === 0 }

  /**
   * constructor
   */
  constructor(context) {
    this.context = context;
    this.loaded  = false;
    this.uses = [];
    this.setuped = false;
    this.sendPv();
  }

  setup() {
    if (this.setuped) return;
    DEFINES.forEach(DEFINE => {
      const isUse = DEFINE.rule ? DEFINE.rule(this) : true;
      if (isUse) {
        this.uses.push(Object.assign({}, DEFINE));
      }
    });
    this.setuped = true;
  }

  load() {
    if (this.loaded) return;
    this.loaded = true;
    this.setup();
    this.loadGa();
    this.uses.forEach(use => {
      this.createGa(use);
    });
  }

  /**
   * GAのトラッキングスクリプトを読み込む
   */
  loadGa() {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js',GoogleAnalyticsObject);
  }

  createGa(define) {
    const ga = window[GoogleAnalyticsObject];
    const options = {
      name: define.name,
    };
    if (define.cookieDomain) {
      options.cookieDomain = define.cookieDomain;
    }
    ga('create', define.id, 'auto', options);
  }

  sendFor(target, data) {
    return new Promise((resolve, reject) => {
      const ga = window[GoogleAnalyticsObject];
      if (typeof ga !== 'function') return reject(new Error(`GAが見つかりません。恐らくロードされていません`));

      const sendData = typeof data === 'string' ? data : Object.assign({}, data, {
        hitCallback: resolve,
        hitCallbackFail: reject,
      });

      ga(target.name + '.send', sendData);
    });
  }

  sendPv() {
    this.load();
    const sendData = 'pageview';
    try {
      this.uses.filter(use => use.pageview).map(use => this.sendFor(use, sendData));
    } catch (err) {
      console.warn(err);
    }
  }

  /**
   * イベント送信
   */
  async send(category, action, label) {
    if (Array.isArray(category)) return this.sends(category);
    this.load();
    if (this.isEmpty) return;

    let log = this.context.$store.getters['config/envIs']('develop');

    if (typeof category === 'object') {
      action = category.action;
      label = category.label;
      log = category.log === undefined ? log : category.log;
      category = category.category;
    }

    const sendData = {
      hitType: 'event',
      // page: '●●●',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: null,
      // dimension1: '●●●',
    };

    try {
      await Promise.all(this.uses.map(use => this.sendFor(use, sendData)));
      if (log) {
        this.logSuccess(sendData);
      }
    } catch (err) {
      this.logError(sendData);
      throw err;
    }
  }

  /**
   * イベント複数送信
   */
  async sends(
    rows,
    log = this.context.$store.getters['config/envIs']('develop')
  ) {
    this.load();
    if (this.isEmpty || rows.length === 0) return;
    const promiseList = rows.map(row => this.send(Object.assign({ log: false }, row)));

    try {
      await Promise.all(promiseList);
      if (log) {
        this.logSuccess(rows);
      }
    } catch(err) {
      this.logError(rows);
      throw err;
    }
  }

  logSuccess(sendData) {
    console.group(`Pushd GA Event.`);
    console.log(`targets: ${this.uses.map(use => use.id).join(', ')}`);
    console.log(sendData);
    console.groupEnd();
  }

  logError(sendData, err) {
    console.group(`Failed push GA Event.`);
    console.log(`targets: ${this.uses.map(use => use.id).join(', ')}`);
    console.log(sendData);
    if (err) console.warn(err);
    console.groupEnd();
  }
}



// WEBPACK FOOTER //
// ./src/js/manager/GaManager.js